import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
  GridToolbarColumnsButton,
  GridToolbarExportContainer,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import FormControl from "@mui/material/FormControl";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CloseIcon from "@mui/icons-material/Close";
import Themdonvi from "components/Danhmuc/Donvi/Themdonvi.js";
import Capnhatdonvi from "components/Danhmuc/Donvi/Capnhatdonvi.js";
import Danhmucdonviexcel from "components/Xuatexcel/Danhmuc/Danhmucdonviexcel.js";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@mui/material/TextField";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Config from "conFig.js";
import styles from "assets/jss/material-dashboard-react/components/tableviewStyle.js";
const useStyles = makeStyles(styles);
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const dvcolumn = [
  {
    field: "stt",
    headerName: "STT",
    width: 80,
    headerAlign: "center",
  },
  {
    field: "tendonvi",
    headerName: "Tên",
    width: 300,
    headerAlign: "center",
  },
  {
    field: "diachidonvi",
    headerName: "Địa chỉ",
    width: 300,
    headerAlign: "center",
  },
  {
    field: "tenphuongxa",
    headerName: "Xã/phường",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "sodienthoai",
    headerName: "Số điện thoại",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "giayphepdkkd",
    headerName: "Số GPKD",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "ngaycapgpdkkd",
    headerName: "Ngày cấp GPKD",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "coquancap",
    headerName: "Cơ quan cấp GPKD",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "nguoidaidien",
    headerName: "Người đại diện",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "sogiayphep",
    headerName: "Số GPKDVT",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "ngaycapgpkdvt",
    headerName: "Ngày cấp GPKDVT",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "ngayhethangpkdvt",
    headerName: "Ngày hết hạn GPKDVT",
    width: 160,
    headerAlign: "center",
  },
  {
    field: "nguoidieuhanh",
    headerName: "Người điều hành",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "loaihinh",
    headerName: "Loại hình",
    width: 210,
    headerAlign: "center",
  },
  {
    field: "ten_trangthaihoatdong",
    headerName: "Trạng thái",
    width: 180,
    headerAlign: "center",
  },
];

export default function Danhmucdonvi() {
  const classes = useStyles();
  const [pageSize, setPageSize] = React.useState(50);
  const [donvi, setDonvi] = React.useState([]);
  const [loaihinh, setLoaihinh] = React.useState([]);
  const [xaphuong, setXaphuong] = React.useState([]);
  const [xaphuong_id, setXaphuong_id] = React.useState(0);
  const [loaihinhvalue, setLoaihinhvalue] = React.useState(0);
  const [donvi_id, setDonvi_id] = React.useState(0);
  const [disableBT, setDisableBT] = React.useState(true);
  const [disableBT1, setDisableBT1] = React.useState(true);
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [openthem, setOpenthem] = React.useState(false);
  const [opensua, setOpensua] = React.useState(false);
  const handleClose = () => {
    setOpenthem(false);
    getdonvi();
  };
  const handleClosesua = () => {
    setOpensua(false);
    getdonvi();
  };
  const openthemdv = () => {
    setOpenthem(true);
    setDisableBT(true); // fix delete button
  };
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
        <GridToolbarColumnsButton />
        <GridToolbarExportContainer>
          <Danhmucdonviexcel />
        </GridToolbarExportContainer>
      </Box>
    );
  };
  const getdonvi = () => {
    var url = Config.backend + "/api/Donvi/getdvvt?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setDonvi(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getxaphuong = () => {
    var url = Config.backend + "/api/Donvi/getpxgialai?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setXaphuong(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getdonvitheoloai = () => {
    setDisableBT(true); // fix delete button
    var url =
      Config.backend +
      "/api/Donvi/getdvvtloaihinhtheophuongxa?loaihinh_id=" +
      loaihinhvalue +
      "&phuongxa_id=" +
      xaphuong_id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setDonvi(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getloaihinhvantai = () => {
    var url =
      Config.backend +
      "/api/Phuongtien/getdmlhvantaitatca?username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setLoaihinh(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const xoadonvi = () => {
    var url = Config.backend + "/api/Donvi/xoadvvt";
    fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        id: donvi_id,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === 1) {
          showNotification();
          getdonvi();
          setDisableBT(true);
        } else {
          showNotification1();
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  React.useEffect(() => {
    getdonvi();
    getxaphuong();
    getloaihinhvantai();
  }, []);
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
        <FormControl style={{ width: "18%" }}>
          <Autocomplete
            freeSolo
            disableClearable
            size="small"
            options={xaphuong}
            getOptionLabel={(option) => option.ten}
            onChange={(event, value) => {
              setXaphuong_id(value.id);
              setDisableBT(true); // fix delete button
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Chọn Xã/phường"
                InputProps={{
                  ...params.InputProps,
                  type: "search",
                  style: {
                    height: "32px",
                    paddingTop: "initial",
                  },
                }}
              />
            )}
          />
        </FormControl>
        <FormControl style={{ width: "18%", marginLeft: 10 }}>
          <Autocomplete
            freeSolo
            disableClearable
            size="small"
            options={loaihinh}
            getOptionLabel={(option) => option.ten}
            onChange={(event, value) => {
              setDisableBT1(false);
              setLoaihinhvalue(value.id);
              setDisableBT(true); // fix delete button
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Chọn loại hình vận tải"
                InputProps={{
                  ...params.InputProps,
                  type: "search",
                  style: {
                    height: "32px",
                    paddingTop: "initial",
                  },
                }}
              />
            )}
          />
        </FormControl>
        <FormControl style={{ width: "8%", marginLeft: 10 }}>
          <Button
            color="primary"
            variant="contained"
            style={{ height: 32 }}
            disabled={disableBT1}
            onClick={getdonvitheoloai}
          >
            Xem
          </Button>
        </FormControl>
        <FormControl style={{ width: "12%", marginLeft: 10 }}>
          <Button
            color="success"
            variant="contained"
            style={{ height: 32 }}
            onClick={openthemdv}
          >
            Thêm mới
          </Button>
        </FormControl>
        <FormControl style={{ width: "8%", marginLeft: 10 }}>
          <Button
            color="error"
            variant="contained"
            style={{ height: 32 }}
            disabled={disableBT}
            onClick={xoadonvi}
          >
            Xóa
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 10 }}>
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            getRowId={(row) => row.id}
            rows={donvi}
            columns={dvcolumn}
            checkboxSelection={false}
            getRowHeight={() => "auto"}
            headerHeight={35}
            onRowClick={(params) => {
              setDonvi_id(params.row.id);
              setDisableBT(false);
            }}
            onCellDoubleClick={(params, event) => {
              if (!event.ctrlKey) {
                setDonvi_id(params.row.id);
                setOpensua(true);
                setDisableBT(true); // fix delete button
              }
            }}
            sx={datagridSx}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={openthem}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={2}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={8}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Thêm đơn vị
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClose} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Themdonvi />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={2}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={opensua}
          onClose={handleClosesua}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={2}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={8}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Cập nhật đơn vị
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClosesua} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Capnhatdonvi donvi_id={donvi_id} />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={2}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Xóa thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Đơn vị này đã có dữ liệu, không thể xóa"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </GridContainer>
  );
}
